<script lang="ts" setup>
  import { computed } from 'vue';
  import { useRealizationTime, useVerifiedCart } from '@storefront/storefront';

  const cart = useVerifiedCart();

  const realization = computed(() => useRealizationTime(cart.value));
</script>
<template>
  <div v-if="realization" class="realization-option-summary">
    <SfIconClock class="realization-option-summary__icon" aria-hidden="true"  />
    <div class="realization-option-summary__content">
      <span class="realization-option-summary__property">{{ $t('SHOP.ORDER.LABEL.SHIPPING_ESTIMATED_AT') }}</span>
      <span class="realization-option-summary__value">{{ realization }}</span>
    </div>
  </div>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .realization-option-summary {
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1.5rem;

    &__icon {
      font-size: 1.25rem;
    }

    &__content {
      display: flex;
      flex-direction: column;
    }

    &__value {
      font-weight: var(--font-weight-semi);
    }

    @include media.query(xl) {
      padding: 0.5rem 1rem;
    }
  }
</style>
